// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3x0Yc","productName":"Table_productName__14epk"};